import { useCallback } from 'react';

/**
 * LikersModalコンポーネントのカスタムフック
 * 
 * 現在のコンポーネントにはロジックが少ないため、将来的な拡張性のための基本構造を提供します。
 * 実際のロジックはUIが必要になったときに実装されます。
 */
const useLikersModal = () => {
  /**
   * モーダルを閉じるハンドラー
   * @param onClose モーダルを閉じる関数
   */
  const handleClose = useCallback((onClose: () => void) => {
    onClose();
  }, []);

  return {
    handleClose,
  };
};

export default useLikersModal; 